import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { renameCard } from 'apps/auth/actions/cardsAction';
import { setFieldError, setNewForm } from 'apps/auth/actions/formAction';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import Loading from 'apps/auth/components/utils/Loading';
import { CARD } from 'apps/auth/constants/Constants';
import { AUTH_CARD_RENAME } from 'apps/auth/constants/UrlConstants';

const FORM_NAME = 'renameCardPopup';

const RenameCardOrAccountPopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        const selectedCard = props.selectedCard;
        const nameField = getField('name', selectedCard.alias, '', true, false, isCard() ? props.cardPlaceholder : props.accountPlaceholder, 'text');
        const cardIdField = getField('id', selectedCard.id);
        const force = getField('force', false);

        props.setNewForm(FORM_NAME, {
            [nameField.name]: nameField,
            [cardIdField.name]: cardIdField,
            [force.name]: force,
        });
    }, []);

    const onSubmitHandler = (fields, data) => {
        if (Object.keys(data.errors).length === 0) {
            props.renameCard(props.selectedCard.id, props.forms[FORM_NAME].fields.name.value);
            popupRef.current?.close();
        } else {
            props.setFieldError(FORM_NAME, 'name', data.errors.name);
        }
    };

    const isCard = () => {
        return props.selectedCard.type === CARD;
    };

    const getTitle = () => {
        return isCard() ? props.cardRenameTitle : props.accountRenameTitle;
    };

    const form = props.forms[FORM_NAME];
    if (!form) {
        return <Loading />;
    }
    return (
        <ComplexPopup
            primaryButtonType="submit"
            primaryButtonForm="rename_card_form_id"
            primaryButtonTabIndex="1002"
            primaryButtonText={isCard() ? props.cardRenameButton : props.accountRenameButton}
            textCenter
            popupRef={popupRef}
        >
            <Form id="rename_card_form_id" action={AUTH_CARD_RENAME} formName={FORM_NAME} fields={form.fields} onSubmitHandler={onSubmitHandler}>
                <ComplexPopupRow>{getTitle()}</ComplexPopupRow>
                <InputText field={form.fields.name} formName={FORM_NAME} focus={true} isNewInput />
            </Form>
        </ComplexPopup>
    );
};

const mapStateToProps = (state) => {
    return {
        forms: state.form,
        cardPlaceholder: state.messages.pageMessages.cardPlaceholder,
        accountPlaceholder: state.messages.pageMessages.accountPlaceholder,
        cardRenameTitle: state.messages.pageMessages.cardRenameTitle,
        accountRenameTitle: state.messages.pageMessages.accountRenameTitle,
        cardRenameButton: state.messages.pageMessages.cardRenameButton,
        accountRenameButton: state.messages.pageMessages.accountRenameButton,
    };
};
RenameCardOrAccountPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    selectedCard: PropTypes.object,
};

export default connect(mapStateToProps, { setNewForm, setFieldError, renameCard })(RenameCardOrAccountPopup);
